import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Device } from '@ubie/core';

@Component({
  selector: 'acl-device-info-v1',
  standalone: false,
  templateUrl: './device-info-v1.component.html',
  styleUrl: './device-info-v1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceInfoV1Component {
  readonly data = input.required<Device>();
  readonly isAccessExpired = input<boolean>(false);
  readonly isCtdLimitReached = input<boolean>(false);
}
